import React from "react"
import styled from "@emotion/styled"
import { useBreakpointIndex } from "@theme-ui/match-media"

const BannerWrapper = styled.div`
    position: relative;
    & img {
        max-width: 100%;
        height: auto;
    }
`

const BannerBackground = styled.div`
    position: relative;
    width: 100%;
    padding-top: 36.5%;
    background: no-repeat center center;
    background-size: cover;
    background-color: #f6f6f6;
`

const CaptionBox = styled.div`
    position: absolute;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    top: 40%;
    transform: translateY(-50%);
    text-align: center;
    width: 70%;
    z-index: 10;

    & p {
        font-size: 18px;
    }

    & .with-image {
        & h1 {
            color: ${(props) => props.theme.colors.background};
            margin-bottom: 0.5rem;
            text-transform: uppercase;
        }
        & p,
        & p span {
            color: ${(props) => props.theme.colors.background} !important;
        }
    }

    & .no-image {
        & h1 {
            color: ${(props) => props.theme.colors.primary};
        }
        & p span {
            color: ${(props) => props.theme.colors.primary} !important;
        }
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[8]}) {
        width: 80%;
        & p {
            font-size: 16px;
        }
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[7]}) {
        & h1 {
            font-size: 50px;
        }
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[6]}) {
        & h1 {
            font-size: 40px;
        }
        & p {
            font-size: 14px;
        }
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        width: 95%;
        & h1 {
            font-size: 35px;
        }
        & p {
            margin: 0;
            font-size: 12px;
        }
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[3]}) {
        & h1 {
            font-size: 30px;
        }

        & p {
            line-height: 1.2;
        }
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[2]}) {
        & h1 {
            font-size: 20px;
            margin-bottom: 0;
        }
        & p {
            font-size: 12px;
        }
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[1]}) {
        & h1 {
            font-size: 18px;
        }
        & p {
            font-size: 11px;
        }
    }
`
const Overlay = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
    z-index: 2;
`

const BreadcrumsContainer = styled.div`
    padding: 0 10%;
    position: relative;
    z-index: 10;

    & .breadcrumbs-wrapper {
        padding-left: 4rem;
        padding-bottom: 0.5rem;
        & > div,
        & > div > a {
            color: ${(props) => props.theme.colors.background};
            margin-bottom: 0;
        }
    }

    @media screen and (min-width: 1800px) {
        & .breadcrumbs-wrapper {
            padding-left: 0;
        }
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        padding: 0 7%;
        & .breadcrumbs-wrapper {
            padding: 0;
        }
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[3]}) {
        padding: 0;
        & .breadcrumbs-wrapper {
            padding: 0 2rem;
        }
    }
`

const ButtonDown = styled.div`
    position: absolute;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    bottom: 1rem;
    z-index: 9;
    text-align: center;
`

function TopBanner({ data }) {
    const breakpoints = useBreakpointIndex()
    let contentWithImage = null
    if (data.imageFile) {
        contentWithImage = (
            <>
                <Overlay />
                <BreadcrumsContainer>
                    <div className="breadcrumbs-wrapper">
                        {data.breadcrumbs}
                    </div>
                </BreadcrumsContainer>
                {breakpoints > 4 && (
                    <ButtonDown>
                        <img src="/icon-arrow-down.svg" />
                    </ButtonDown>
                )}
            </>
        )
    }
    return (
        <>
            <BannerWrapper>
                <BannerBackground
                    style={{ backgroundImage: `url(${data.imageFile})` }}
                >
                    {contentWithImage}
                    <CaptionBox className="caption-box-topbanner">
                        <div
                            className={
                                data.imageFile ? "with-image" : "no-image"
                            }
                        >
                            <h1>{data.title}</h1>
                            {breakpoints > 4 && (
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: data.description,
                                    }}
                                />
                            )}
                        </div>
                    </CaptionBox>
                </BannerBackground>
            </BannerWrapper>
        </>
    )
}

export default TopBanner
